import React from 'react';
import { Container, Sprite } from '@pixi/react';

function RePlayInfoIcon({ containerConfig, rePlayInfoIcon }) {
  return (
    <Container {...containerConfig}>
      <Sprite texture={rePlayInfoIcon} anchor={0.5} />
    </Container>
  );
}

export default RePlayInfoIcon;
